export const toolZh = {
  timestamp: {
    title: 'Unix 时间戳转换器',
    subtitle: '在 Unix 时间戳和可读日期之间转换，支持自动检测、实时模式和批量处理。',
    seo: {
      title: 'Unix 时间戳转换器 - 实时、批量转换与自动检测 | CikaStudio',
      description: '免费的 Unix 时间戳转换工具，支持实时模式、自动检测（秒/毫秒/微秒/纳秒）、批量转换、时区支持和丰富的日期元数据。100% 客户端处理，保护隐私。',
    },
    liveMode: {
      title: '当前时间戳',
      description: '每秒实时更新',
      pause: '暂停',
      resume: '继续',
      copyHint: '点击复制',
    },
    conversion: {
      timestampToDate: '时间戳 → 日期',
      dateToTimestamp: '日期 → 时间戳',
      swapDirection: '切换方向',
    },
    input: {
      placeholder: '输入时间戳...',
      label: '输入',
    },
    unit: {
      seconds: '秒',
      milliseconds: '毫秒',
      microseconds: '微秒',
      nanoseconds: '纳秒',
      auto: '自动检测',
    },
    timezone: {
      label: '时区',
      local: '本地',
    },
    output: {
      label: '转换结果',
      formats: '输出格式',
    },
    format: {
      iso8601: 'ISO 8601',
      rfc2822: 'RFC 2822',
      sql: 'SQL 日期时间',
      unixSeconds: 'Unix (秒)',
      unixMilliseconds: 'Unix (毫秒)',
      unixMicroseconds: 'Unix (微秒)',
      unixNanoseconds: 'Unix (纳秒)',
      humanReadable: '人类可读',
    },
    metadata: {
      title: '日期元数据',
      dayOfWeek: '星期',
      dayOfYear: '年内第几天',
      weekNumber: '周数',
      quarter: '季度',
      leapYear: '闰年',
      dst: '夏令时',
      timezone: '时区',
      utcOffset: 'UTC 偏移',
      yes: '是',
      no: '否',
      active: '生效',
      inactive: '未生效',
    },
    batch: {
      title: '批量转换',
      single: '单个',
      batch: '批量',
      placeholder: '在此粘贴时间戳，每行一个...',
      convert: '转换',
      downloadCSV: '下载 CSV',
      clearAll: '清空全部',
      column: {
        input: '输入',
        unit: '单位',
        iso: 'ISO 8601',
        local: '本地时间',
        seconds: 'Unix (秒)',
        milliseconds: 'Unix (毫秒)',
      },
    },
    error: {
      invalidTimestamp: '无效的时间戳，请输入有效的数字。',
      invalidDate: '无效的日期，请选择有效的日期和时间。',
      outOfRange: '时间戳超出支持的日期范围。',
    },
  },
  content: {
    privacy: {
      title: '隐私与安全',
      description: '🔒 所有时间戳转换均在您的浏览器本地完成。任何数据都不会被上传到服务器。',
    },
    guide: {
      title: '如何使用时间戳转换器',
      description: '在 Unix 时间戳和人类可读日期之间进行转换，支持自动检测、实时模式和批量处理。',
      steps: [
        { title: '输入时间戳或日期', description: '粘贴 Unix 时间戳（秒或毫秒）或键入人类可读的日期。工具会自动检测输入格式。' },
        { title: '查看转换结果', description: '以多种格式查看转换后的值：本地时间、UTC、ISO 8601 和原始时间戳。实时模式会即时更新。' },
        { title: '批量处理', description: '粘贴多个时间戳或日期（每行一个）以一次性转换它们。将结果复制到剪贴板或下载为 CSV 文件。' },
      ],
    },
    features: {
      title: '核心功能',
      items: [
        '自动检测秒和毫秒时间戳',
        '多种输出格式：本地时间、UTC、ISO 8601',
        '实时模式，带实时更新时钟',
        '批量处理多个值',
        '支持复制和 CSV 下载',
        '100% 客户端处理 — 零数据上传',
      ],
    },
    faq: {
      title: '常见问题',
      items: [
        { question: '我的数据会被发送到服务器吗？', answer: '不会。所有转换均在您的浏览器内使用 JavaScript Date 对象完成。您的时间戳绝不会离开您的设备。' },
        { question: '支持时区转换吗？', answer: '支持。转换器显示您的本地时区和 UTC。您还可以输入带有时区偏移量的日期以进行精确转换。' },
        { question: '什么是 Unix 纪元？', answer: 'Unix 纪元是 1970 年 1 月 1 日 00:00:00 UTC。Unix 时间戳计算自该时间点以来的秒数（或毫秒数）。' },
      ],
    },
    related: {
      title: '相关工具',
      tools: [
        { name: 'Cron 解析器', url: '/developer/cron-parser', description: '将标准 Cron 表达式解析为人类可读的计划。' },
        { name: '单位转换器', url: '/converter/unit-converter', description: '即时在 10 多个单位类别之间进行转换。' },
        { name: '百分比计算器', url: '/utility/percentage-calculator', description: '在浏览器中进行即时百分比计算。' },
      ],
    },
  },
};